import template from './stopword-list.html.twig';
import './stopword-list.scss';
import '../../component/stopword-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-mining-stopword-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'word',
            sortDirection: 'ASC',
            limit: 25,
            term: '',
            languageFilter: null,
            activeFilter: null,
            activeModal: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdes_mining_stopword');
        },

        languageOptions() {
            return [
                { value: 'de', label: 'Deutsch' },
                { value: 'en', label: 'English' },
                { value: 'fr', label: 'Français' },
            ];
        },

        activeOptions() {
            return [
                { value: true, label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.activeYes') },
                { value: false, label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.activeNo') },
            ];
        },

        columns() {
            return [{
                property: 'word',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnWord'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'languageId',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnLanguage'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnActive'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnCreatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },

        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.deleteConfirmText', {
                word: this.itemToDelete.word,
                language: this.getLanguageLabel(this.itemToDelete.languageId),
            });
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            if (this.term) {
                criteria.addFilter(Criteria.contains('word', this.term));
            }
            if (this.languageFilter) {
                criteria.addFilter(Criteria.equals('languageId', this.languageFilter));
            }
            if (this.activeFilter !== null) {
                criteria.addFilter(Criteria.equals('active', this.activeFilter));
            }

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onSearch(term) {
            this.term = term;
            this.page = 1;
            this.getList();
        },

        onLanguageFilterChange(value) {
            this.languageFilter = value;
            this.page = 1;
            this.getList();
        },

        onActiveFilterChange(value) {
            this.activeFilter = value;
            this.page = 1;
            this.getList();
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        getLanguageLabel(languageId) {
            const option = this.languageOptions.find((entry) => entry.value === languageId);
            return option ? option.label : languageId;
        },

        onAddStopword() {
            this.currentEntity = this.repository.create();
            this.currentEntity.word = '';
            this.currentEntity.languageId = 'de';
            this.currentEntity.active = true;
            this.activeModal = true;
        },

        onEditStopword(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.currentEntity = null;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },
    },
});
